import { render, staticRenderFns } from "./GroupBanner.vue?vue&type=template&id=315d4591&scoped=true&"
import script from "./GroupBanner.vue?vue&type=script&lang=js&"
export * from "./GroupBanner.vue?vue&type=script&lang=js&"
import style0 from "./GroupBanner.vue?vue&type=style&index=0&id=315d4591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d4591",
  null
  
)

export default component.exports